import { IApplicationState } from '../../../../../types/types';

export const checkNewValueExistsSelector = (
    state: IApplicationState
) => state.cookieDialog.newPerformanceAllowedValue !== undefined;
